export const addFloats = (a: number, b: number, decimals: number = 2) => {
    const factor = Math.pow(10, decimals);
    return (Math.round(a * factor) + Math.round(b * factor)) / factor;
}